import { Link } from 'react-router-dom';
import { featuredCollections } from '@/mocks/videos';

export default function FeaturedCollection() {
  return (
    <section className="w-full bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
            精选合集
          </h2>
          <p className="text-foreground-500 text-sm">
            系统化内容体系，助你深度学习
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredCollections.map((collection) => (
            <Link
              key={collection.id}
              to={`/category/jiaoyu`}
              className="group block bg-background-100 rounded-xl border border-background-200/60 hover:border-accent-300 overflow-hidden transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={collection.coverImage}
                  alt={collection.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-background-50 text-xs bg-white/20 backdrop-blur-sm px-2 py-1 rounded-md">
                    {collection.videoCount} 集内容
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {collection.title}
                </h3>
                <p className="text-foreground-500 text-xs mt-1.5 line-clamp-2 leading-relaxed">
                  {collection.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}